import {
  PatchDamagedAdjusterAttachedImagesPropsType,
  PatchDamagedAdjusterAttachedImagesQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedAdjusterAttachedImages/patchDamagedAdjusterAttachedImagesQuery.type';
import { patchDamagedAdjusterAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedAdjusterAttachedImages/patchDamagedAdjusterAttachedImagesQueryFunction';

export const patchDamagedAdjusterAttachedImagesQueryOptions = ({
  type,
  fileType,
}: PatchDamagedAdjusterAttachedImagesPropsType) => {
  return {
    mutationKey: ['patchDamagedAdjusterAttachedImages'],
    mutationFn: (params: PatchDamagedAdjusterAttachedImagesQueryParamsType) =>
      patchDamagedAdjusterAttachedImagesFunction({ ...params, type, fileType }),
  };
};
